import gql from 'graphql-tag';
const putUserProfiles = gql(`
  mutation PutUserProfiles(
    $user: String!
    $type: String!
    $data: AWSJSON
  ) {
    putUserProfiles(
      user: $user
      type: $type
      data: $data
    ) {
      user
      type
      data
    }
  }
`);
export default putUserProfiles;
